/**
 * Warstwa API: PAKIETY SZKOLEŃ (polecenie właściciela 2026-09-14).
 *
 * Trasa backendu: `api/elearning/pakiety` (PakietySzkolenController). Zarządzanie (lista, zapis, dezaktywacja,
 * przypisanie, postępy, automat) stoi za tą samą bramką, co zarządzanie kursami e-learningu; `moje` — każdy o sobie;
 * `pracownika/{id}` — bramka e-teczki (własne bez klucza, cudze z ModuleETeczka + zakres osobowy).
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do wspólnego
 * `apiService`. Nazwy muszą być unikalne w całej aplikacji (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Lista pakietów z kursami i licznikami przypisań (zarządzanie e-learningiem). */
        getPakietySzkolen: (tylkoAktywne = false) =>
            api.get("/elearning/pakiety", { params: tylkoAktywne ? { tylkoAktywne: true } : {} }),
        getPakietSzkolen: (id) => api.get(`/elearning/pakiety/${id}`),
        createPakietSzkolen: (dto) => api.post("/elearning/pakiety", dto),
        updatePakietSzkolen: (id, dto) => api.put(`/elearning/pakiety/${id}`, dto),
        /** Dezaktywacja / przywrócenie — pakietów się nie kasuje (przypisania są historią szkoleń pracownika). */
        ustawAktywnyPakietSzkolen: (id, aktywny) =>
            api.patch(`/elearning/pakiety/${id}/aktywny`, null, { params: { aktywny } }),
        /** Ręczne przypisanie: `{ userIds: [..] }` albo `{ departmentId }` (dział z pod-działami). */
        przypiszPakietSzkolen: (id, zadanie) => api.post(`/elearning/pakiety/${id}/przypisz`, zadanie),
        /** Postęp wszystkich osób przypisanych do pakietu. */
        getPostepyPakietuSzkolen: (id) => api.get(`/elearning/pakiety/${id}/postepy`),
        /** Ręczne uruchomienie cyklu automatu „na zatrudnienie”. */
        uruchomAutomatPakietowSzkolen: () => api.post("/elearning/pakiety/uruchom-automat"),
        /** Pakiety zalogowanego z postępem (strona /szkolenia). */
        getMojePakietySzkolen: () => api.get("/elearning/pakiety/moje"),
        /** Pakiety wskazanego pracownika z postępem (sekcja w e-teczce). */
        getPakietySzkolenPracownika: (userId) => api.get(`/elearning/pakiety/pracownika/${userId}`),
    };
}
